import { IBriefingNote } from '@pages/campaigns/campaigns.interface';

// Wave 11 - mirrors campaign-form-payload.service.ts's getBriefingNotes() persistence gate exactly,
// so added/removed only fire for the same "has this note actually got content" transition the
// backend itself uses to decide whether to store the note at all.
export function hasBriefingNoteContent(note: IBriefingNote | null | undefined): boolean {
  return !!note?.note?.trim() || !!note?.files?.length;
}

export function haveBriefingNotesChanged(
  previous: IBriefingNote | null | undefined,
  next: IBriefingNote | null | undefined,
): boolean {
  if ((previous?.note ?? null) !== (next?.note ?? null)) {
    return true;
  }

  const previousFileIds = new Set((previous?.files ?? []).map((file) => file.id ?? file.fileId));
  const nextFileIds = new Set((next?.files ?? []).map((file) => file.id ?? file.fileId));

  if (previousFileIds.size !== nextFileIds.size) {
    return true;
  }

  return [...nextFileIds].some((id) => !previousFileIds.has(id));
}
